import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { LandingServiceService } from 'src/app/Services/landing-service.service';
import { MatTableDataSource } from '@angular/material/table';


@Component({
  selector: 'app-faqbody',
  templateUrl: './faqbody.component.html',
  styleUrls: ['./faqbody.component.scss'],
})
export class FAQBodyComponent implements OnInit {


  displayedColumns: string[] = ['nameFaq'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  panelOpenState = false;

  constructor(
    private landingService: LandingServiceService,
    private fb: FormBuilder
  ) { }

  faqForm: FormGroup;
  generalFaqs: any = [];
  expertFaqs:any=[];
  reviewerFaqs:any=[];
  facultyFaqs: any = [];
  instituteFaqs: any = [];
  studentFaqs: any = [];
  nodalFaqs:any=[];
  allFaqs: any = [];
  selectedResults: any;
  length: any;
  pageSize = 10;
  pageSizeOptions: number[] = [1, 2, 5, 10];
  pageEvent: PageEvent;
  dataFaq: any = [];
  tempFaq:any=[];
  nature:any;

  ngOnInit(): void {
    this.faqForm = this.fb.group({
      role: [null, Validators.required],
      nature: [null, Validators.required],
    });

    this.landingService.getAllFaqs().subscribe((response) => {
      this.allFaqs = response['faqs'];
      //this.selectedResults = this.allFaqs;
      this.allFaqs.forEach((element) => {
        switch (element['role_id']) {
          case 3:
            this.expertFaqs.push(element);
            break;
          case 4:
            this.reviewerFaqs.push(element);
            break;
          case 5:
            this.instituteFaqs.push(element);
            break;
          case 6:
            this.studentFaqs.push(element);
            break;
          // case 8:
          //   this.facultyFaqs.push(element);
          //   break;
          case 10:
            this.nodalFaqs.push(element);
            break;
          default:
            this.generalFaqs.push(element);
            break;
        }
      });
      this.onSubmit({ 'role': '2' });
      this.faqForm.controls.role.setValue("2");
    });
  }
  public search: string = '';

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }


  onSubmit(data) {
    switch (data.role) {
      case null:
        this.dataFaq = this.generalFaqs;
        break;
      case '1':
        this.dataFaq = this.allFaqs;
        break;
      case '2':
        this.dataFaq = this.generalFaqs;
        break;
      case '3':
        this.dataFaq = this.expertFaqs;
          break;
      case '4':
        this.dataFaq = this.reviewerFaqs;
        break;
      case '5':
        this.dataFaq = this.instituteFaqs;
        break;
      case '6':
        this.dataFaq = this.studentFaqs;
        break;
      // case '8':
      //   this.dataFaq = this.facultyFaqs;
      //   break;
      case '10':
        this.dataFaq = this.nodalFaqs;
        break;
    }

    if(data.nature){
      this.tempFaq=[];

      this.dataFaq.forEach(element => {
        if(element.nature==data.nature){
          this.tempFaq.push(element);
        }
      });
      this.dataFaq=this.tempFaq;
    }
    this.dataFaq;
    this.dataSource = new MatTableDataSource(this.dataFaq);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.search = '';


  }
  
  // getData(event?: PageEvent) {
  //   this.selectedResults = this.dataSource.slice(
  //     event.pageIndex * event.pageSize,
  //     event.pageIndex * event.pageSize + event.pageSize
  //   );
  //   return event;
  // }
}

